import React from 'react'
import styled from '@emotion/styled'

import { GenericLoader, MUIRouterLink } from '@edge/spark/ui-mui'

export const TextContainer = styled.div`
    font-size: 14px;
`

export const FormLabel = styled.label`
    font-size: 14px;
    padding-right: 8px;
    color: rgba(0, 0, 0, 0.38);
`

interface Props {
    label: string
    value?: string | null | React.ReactNode
    loading?: boolean
    href?: string | null | false
    target?: string
    style?: React.CSSProperties
    tabIndex?: number
}

export const InformationItem: React.FC<Props> = ({
    label,
    value,
    loading = false,
    href,
    target,
    style,
    tabIndex = -1,
}: Props) => {
    return (
        <div style={style}>
            <FormLabel>{label}</FormLabel>
            <TextContainer>
                <GenericLoader loading={loading} skeletonProps={{ height: 19, width: 150 }}>
                    {href ? (
                        <MUIRouterLink
                            color="primary"
                            href={href}
                            underline="hover"
                            target={target}
                            tabIndex={tabIndex}
                        >
                            {value}
                        </MUIRouterLink>
                    ) : (
                        value || '—'
                    )}
                </GenericLoader>
            </TextContainer>
        </div>
    )
}
